export default __webpack_public_path__ + "static/media/bird2.ff88e66a.png";